import React from 'react';

import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getCertificaciones from '../../../graphql/querys/tramites/getCertificaciones.graphql';
import deleteCertificacion from '../../../graphql/mutations/tramites/deleteCertificacion.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import { descargarCSV } from '../funciones/descargarCSV';

import getCertificacionesPorRangoConFiltros from '../../../graphql/querys/tramites/getCertificacionesPorRangoConFiltros.graphql';
import getCantidadCertificacionesConFiltros from '../../../graphql/querys/tramites/getCantidadCertificacionesConFiltros.graphql';
import getCantidadCertificacionesPorTipo from '../../../graphql/querys/tramites/getCantidadCertificacionesPorTipo.graphql';
import getCertificacionesPorRango from '../../../graphql/querys/tramites/getCertificacionesPorRango.graphql';

import convertBase64toBlob from '../../common/documentos/convertBase64toBlob';
import TablaCertificaciones from './TablaCertificaciones';
import { errorService } from '../../../graphql/utils/utils';

const confirm = Modal.confirm;

@compose(
  graphql(getUsuario),
  graphql(deleteCertificacion, {
    name: 'deleteCert',
    options: {
      refetchQueries: [{ query: getCertificaciones }],
    },
  })
)
class VerCertificaciones extends React.Component {
  constructor(props) {
    super(props);

    let fechaIni = moment()
      .subtract(7, 'd')
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toDate();

    let fechaFin = moment()
      .endOf('day')
      .toDate();

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
      listaOriginal: [],
      fechaInicio: fechaIni,
      fechaFin: fechaFin,
      filtroNombre: null,
      filtroApellido: null,
      filtroTipo: null,
      filtroDocumento: null,
      pagina: 1,
      cantidadPorPagina: 10,
      cantidadTotal: 0,
      loadingTabla: false,
      arregloTipoCantidad: [],
    };

    this.onDelete = this.onDelete.bind(this);
  }

  componentDidMount() {
    this.getCertificacionesPorRangoConFiltros();
  }

  getCertificacionesPorRangoConFiltros = () => {
    this.setState({ loadingTabla: true });

    this.props.client
      .query({
        query: getCantidadCertificacionesPorTipo,
        variables: {
          fechaInicial: this.state.fechaInicio,
          fechaFinal: this.state.fechaFin,
          filtroNombre: this.state.filtroNombre,
          filtroApellido: this.state.filtroApellido,
          filtroDocumento: this.state.filtroDocumento,
          filtroTipo: this.state.filtroTipo,
        },
      })
      .then(respuesta => {
        let certificacionesPorTipo =
          respuesta.data.getCantidadCertificacionesPorTipo;
        let arregloTipoCantidad = _.map(certificacionesPorTipo, par => {
          return {
            nombre: par.tipoCertificacion.nombre,
            cantidad: par.count,
          };
        });
        this.setState({
          ...this.state,
          arregloTipoCantidad,
        });
      })
      .catch(error => {
        notification.error({
          message: 'Error en la obtencion de cantidades',
          description:
            'Surgio un error a la hora de obtener las cantidades de tipos de certificaciones',
        });
        errorService(error, {
          errorEscrito:
            'Error a la hora de buscar las cantidades de tipos de certificaciones',
          fechaInicial: this.state.fechaInicio,
          fechaFinal: this.state.fechaFin,
          filtroNombre: this.state.filtroNombre,
          filtroApellido: this.state.filtroApellido,
          filtroDocumento: this.state.filtroDocumento,
          filtroTipo: this.state.filtroTipo,
          pagina: this.state.pagina,
          cantidadPorPagina: this.state.cantidadPorPagina,
        });
        console.info('<--error-->');
        console.log(error);
        console.info('<--/error-->');
      });

    this.props.client
      .query({
        query: getCantidadCertificacionesConFiltros,
        variables: {
          fechaInicial: this.state.fechaInicio,
          fechaFinal: this.state.fechaFin,
          filtroNombre: this.state.filtroNombre,
          filtroApellido: this.state.filtroApellido,
          filtroDocumento: this.state.filtroDocumento,
          filtroTipo: this.state.filtroTipo,
        },
      })
      .then(resp => {
        if (
          resp.data.getCantidadCertificacionesConFiltros ||
          resp.data.getCantidadCertificacionesConFiltros == 0
        ) {
          this.setState({
            cantidadTotal: resp.data.getCantidadCertificacionesConFiltros,
          });

          // console.log('VOY A LLAMAR CON: ', this.state);

          this.props.client
            .query({
              query: getCertificacionesPorRangoConFiltros,
              variables: {
                fechaInicial: this.state.fechaInicio,
                fechaFinal: this.state.fechaFin,
                filtroNombre: this.state.filtroNombre,
                filtroApellido: this.state.filtroApellido,
                filtroDocumento: this.state.filtroDocumento,
                filtroTipo: this.state.filtroTipo,
                pagina: this.state.pagina,
                cantidadPorPagina: this.state.cantidadPorPagina,
              },
              fetchPolicy: 'network-only',
            })
            .then(res => {
              console.log('respuesta=>>', res);
              // console.log('RES: ', res);

              this.setState(
                {
                  ...this.state,
                  listaTotal: res.data.getCertificacionesPorRangoConFiltros,
                  listaOriginal: res.data.getCertificacionesPorRangoConFiltros,
                  primeraCarga: false,
                  loadingTabla: false,
                },
                function() {
                  this.ordenarLista(
                    this.state.pagina,
                    this.state.cantidadPorPagina
                  );
                }
              );
            })
            .catch(err => {
              console.log('ERROR EN EL CERTIFICACIONES POR RANGO: ');
              console.log(err);
              errorService(err, {
                fechaInicial: this.state.fechaInicio,
                fechaFinal: this.state.fechaFin,
                filtroNombre: this.state.filtroNombre,
                filtroApellido: this.state.filtroApellido,
                filtroDocumento: this.state.filtroDocumento,
                filtroTipo: this.state.filtroTipo,
                pagina: this.state.pagina,
                cantidadPorPagina: this.state.cantidadPorPagina,
              });

              Modal.error({
                title: 'Error en la busqueda de certificaciones',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        }
      })
      .catch(err => {
        console.log(
          'ERROR A LA HORA DE OBTENER LA CANTIDAD TOTAL DE DOCUMENTOS'
        );
        console.log('EL ERROR ES: ', err);
        errorService(err, {
          fechaInicial: this.state.fechaInicio,
          fechaFinal: this.state.fechaFin,
          filtroNombre: this.state.filtroNombre,
          filtroApellido: this.state.filtroApellido,
          filtroDocumento: this.state.filtroDocumento,
          filtroTipo: this.state.filtroTipo,
        });
      });
  };

  onDelete(id_certificacion) {
    //TODO: Hacer el onDelete.
    // console.log("Se desea eliminar la certificacion con id ", id_certificacion);

    let { usuario } = this.props;

    if (usuario.rol == 'SUPERVISOR' || usuario.rol == 'FUNCIONARIO') {
      let yo = this;
      confirm({
        title:
          'Realmente quiere eliminar esta certificacion y su respectiva venta?',
        content: 'Esta accion no podrá deshacerse',
        onOk() {
          yo.props
            .deleteCert({
              variables: { _id: id_certificacion },
            })
            .then(res => {
              let id = res.data.deleteCertificacion;

              if (id) {
                yo.eliminarElementoYActualizarLista(id);

                notification.warning({
                  message:
                    'Certificacion y su respectiva venta eliminadas con exito',
                  description: 'Se ha eliminado la certificacion exitosamente',
                });
              }
            })
            .catch(err => {
              console.log(
                'Existio un error a la hora de eliminar la certificacion y/o su venta'
              );
              console.log(err);
              errorService(err, {
                _id: id_certificacion,
              });
              Modal.error({
                title: 'Error en la eliminacion de la certificacion y su venta',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    } else {
      Modal.error({
        title:
          'Usted no tiene los permisos necesarios para realizar esta operación',
        content:
          'Para poder realizar esta función, debe tener mas permisos en su cuenta de los que tiene ahora mismo. Por favor, en caso de ser necesario, comuníquese con mesa de ayuda del departamento de informática.',
      });
    }
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];
    let total = this.state.cantidadTotal;

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
        cantidadTotal: total - 1,
      },
      function() {
        this.ordenarLista(this.state.pagina, this.state.cantidadPorPagina);
      }
    );
  };

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState(
      {
        ...this.state,
        filtroNombre: filtro,
        pagina: 1,
      },
      () => {
        this.getCertificacionesPorRangoConFiltros();
      }
    );
  };

  filtrarPorApellido = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState(
      {
        ...this.state,
        filtroApellido: filtro,
        pagina: 1,
      },
      () => {
        this.getCertificacionesPorRangoConFiltros();
      }
    );
  };

  filtrarPorDocumento = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.
    this.setState(
      {
        ...this.state,
        filtroDocumento: filtro,
        pagina: 1,
      },
      () => {
        this.getCertificacionesPorRangoConFiltros();
      }
    );
  };

  filtrarPorTipo = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState(
      {
        ...this.state,
        filtroTipo: filtro,
        pagina: 1,
      },
      () => {
        this.getCertificacionesPorRangoConFiltros();
      }
    );
  };

  // eslint-disable-next-line no-unused-vars
  onChange = (date, dateString) => {
    if (date[0].toDate().getFullYear() < 2020) {
      Modal.error({
        title: 'Advertencia',
        content: 'Debe seleccionar fechas que sean posteriores al año 2019',
      });
    } else {
      this.setState(
        {
          ...this.state,
          fechaInicio: date[0]
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .toDate(),
          fechaFin: date[1]
            .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
            .toDate(),
          pagina: 1,
        },
        () => {
          this.getCertificacionesPorRangoConFiltros();
        }
      );
    }
  };

  // eslint-disable-next-line no-unused-vars
  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        certificacion => {
          // return certificacion.persona.apellido.toUpperCase();
          return certificacion.fecha_creacion;
        },
      ],
      ['desc']
    );

    listaOrdenada.map(e => {
      if (e.venta) e.cantidad = e.venta.detalleVentaSql[0].cantidad;
    });

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaOrdenada,
    });
  };

  onDescargar = () => {
    // console.log("entre a descargar");

    this.props.client
      .query({
        query: getCertificacionesPorRango,
        variables: {
          fechaInicial: this.state.fechaInicio,
          fechaFinal: this.state.fechaFin,
        },
        fetchPolicy: 'network-only',
      })
      .then(res => {
        // console.log('respuesta descargar', res);
        if (res.data.getCertificacionesPorRango) {
          let data = _.map(
            res.data.getCertificacionesPorRango,
            certificacion => {
              return {
                tipo_doc: certificacion.persona.tipo_doc,
                num_doc: certificacion.persona.num_doc,
                nombre: certificacion.persona.nombre,
                apellido: certificacion.persona.apellido,
                tipo: certificacion.tipo_certificacion.nombre,
                fecha: moment(certificacion.fecha_creacion).format(
                  'DD/MM/YYYY'
                ),
                usuario: certificacion.creador
                  ? certificacion.creador.apellido.toUpperCase()
                  : '-',
              };
            }
          );
          descargarCSV(
            [
              'Tipo Doc',
              'Num Doc',
              'Nombre',
              'Apellido',
              'Tipo de Certificacion',
              'Fecha',
              'Usuario',
            ],
            data,
            `ReporteDeCertificaciones-${moment().format(
              'DD/MM/YYYY-HH:mm'
            )}.csv`
          );
        }
      });
  };

  generarRecibo = base64 => {
    const base64PdfBlob = convertBase64toBlob(base64, 'application/pdf');
    const filePdf = URL.createObjectURL(base64PdfBlob);
    window.open(filePdf);
  };

  cambiarPagina = pagina => {
    this.setState(
      {
        pagina: pagina,
      },
      () => {
        this.getCertificacionesPorRangoConFiltros();
      }
    );
  };

  cambiarTamañoPagina = tamaño => {
    this.setState({
      cantidadPorPagina: tamaño,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    return (
      <div style={{ marginTop: 30 }}>
        <TablaCertificaciones
          certificaciones={this.state.lista}
          history={this.props.history}
          onDelete={this.onDelete}
          imprimir={this.onImprimir}
          filtrarPorNombre={this.filtrarPorNombre}
          filtrarPorApellido={this.filtrarPorApellido}
          filtrarPorDocumento={this.filtrarPorDocumento}
          filtrarPorTipo={this.filtrarPorTipo}
          textoFiltroNombre={this.state.filtroNombre}
          textoFiltroApellido={this.state.filtroApellido}
          textoFiltroDocumento={this.state.filtroDocumento}
          textoFiltroTipo={this.state.filtroTipo}
          onChange={this.onChange}
          onDescargar={this.onDescargar}
          fechaInicio={this.state.fechaInicio}
          fechaFin={this.state.fechaFin}
          pagina={this.state.pagina}
          cambiarPagina={this.cambiarPagina}
          cambiarTamañoPagina={this.cambiarTamañoPagina}
          total={this.state.cantidadTotal}
          cantidadPorPagina={this.state.cantidadPorPagina}
          loadingTabla={this.state.loadingTabla}
          usuario={this.props.usuario}
          arregloTipoCantidad={this.state.arregloTipoCantidad}
          generarRecibo={this.generarRecibo}
        />
      </div>
    );
  }
}

export default withApollo(VerCertificaciones);
